import _slicedToArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React, { useState, useEffect } from 'react';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import isValid from 'date-fns/isValid';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ruLocale from 'date-fns/locale/ru';
import { CircularProgress, IconButton, Toolbar, Button, Typography } from '@material-ui/core';
import { Clear, Event } from '@material-ui/icons';
import classnames from 'classnames';
import { isYearOnlyView } from '@material-ui/pickers/_helpers/date-utils';
var stringFormat = 'dd.MM.yyyy HH:mm';

var formatValue = function formatValue(value) {
  var formattedValue = !value ? null : parse(value, stringFormat, new Date());

  if (!isValid(formattedValue)) {
    formattedValue = null;
  }

  return formattedValue;
};

var minDate = new Date('1800-01-01');
var maxDate = new Date('2100-01-01');
export var renderToolbarComponent = function renderToolbarComponent(_ref) {
  var classes = _ref.classes,
      beforeText = _ref.beforeText,
      afterText = _ref.afterText;
  return function (props) {
    var _classnames;

    var date = props.date,
        views = props.views,
        setOpenView = props.setOpenView,
        isLandscape = props.isLandscape,
        openView = props.openView;
    var isYearOnly = React.useMemo(function () {
      return isYearOnlyView(views);
    }, [views]); // const isYearAndMonth = React.useMemo(() => isYearAndMonthViews(views), [views]);
    // const [customTimeMode, setCustomTimeMode] = useState<boolean>(false);
    // const [customHour, setCustomHour] = useState<string>(format(date, 'HH'));
    // const [customMinute, setCustomMinute] = useState<string>(format(date, 'mm'));
    //
    // const openCustomTimeMode = (_event): void => {
    //   setCustomTimeMode(true);
    //   setOpenView('');
    // };
    //
    // const changeCustomHour = (direction: 'up' | 'down'): void => {
    //   let hour = Number(customHour);
    //   if(direction === 'up') {
    //     hour = hour < 23 ? hour + 1 : 0
    //   } else if(direction === 'down') {
    //     hour = hour > 0 ? hour - 1 : 23
    //   }
    //   setCustomHour(hour < 10 ? `0${hour}` : String(hour))
    // };
    // const changeCustomMinute = (direction: 'up' | 'down'): void => {
    //   let minute = Number(customMinute);
    //   if(direction === 'up') {
    //     minute = minute < 59 ? minute + 1 : 0
    //   } else if(direction === 'down') {
    //     minute = minute > 0 ? minute - 1 : 59
    //   }
    //   setCustomMinute(minute < 10 ? `0${minute}` : String(minute))
    // };

    return React.createElement(React.Fragment, null, React.createElement(Toolbar, {
      className: classnames((_classnames = {}, _defineProperty(_classnames, classes.datePickerToolbar, !isYearOnly), _defineProperty(_classnames, classes.datePickerToolbarLandscape, isLandscape), _classnames))
    }, React.createElement("div", {
      className: classes.datePickerToolbarButtonsDate
    }, beforeText && React.createElement(Typography, {
      variant: 'button',
      className: classes.datePickerToolbarButtonsDateTxt
    }, beforeText, "\xA0\xA0"), React.createElement(Button, {
      variant: 'text',
      onClick: function onClick() {
        setOpenView('date');
      },
      className: classes.datePickerToolbarButtonsDateBtn
    }, React.createElement(Typography, {
      variant: 'button',
      className: classnames(classes.datePickerToolbarButtonsDateTxt, _defineProperty({}, classes.datePickerToolbarButtonsDateTxtSelected, openView === 'date'))
    }, format(date, 'd'))), React.createElement(Button, {
      variant: 'text',
      onClick: function onClick() {
        setOpenView('month');
      },
      className: classes.datePickerToolbarButtonsDateBtn
    }, React.createElement(Typography, {
      variant: 'button',
      className: classnames(classes.datePickerToolbarButtonsDateTxt, _defineProperty({}, classes.datePickerToolbarButtonsDateTxtSelected, openView === 'month'))
    }, format(date, 'MMMM', {
      locale: ruLocale
    }))), React.createElement(Button, {
      variant: 'text',
      onClick: function onClick() {
        setOpenView('year');
      },
      className: classes.datePickerToolbarButtonsDateBtn
    }, React.createElement(Typography, {
      variant: 'button',
      className: classnames(classes.datePickerToolbarButtonsDateTxt, _defineProperty({}, classes.datePickerToolbarButtonsDateTxtSelected, openView === 'year'))
    }, format(date, 'yyyy'))), afterText && React.createElement(Typography, {
      variant: 'button',
      className: classes.datePickerToolbarButtonsDateTxt
    }, "\xA0\xA0", afterText)), React.createElement("div", {
      className: classes.datePickerToolbarButtonsDate
    }, React.createElement(Button, {
      variant: 'text',
      onClick: function onClick() {
        return setOpenView('hours');
      },
      className: classes.datePickerToolbarButtonsDateBtn
    }, React.createElement(Typography, {
      variant: 'button',
      className: classnames(classes.datePickerToolbarButtonsDateTxt, _defineProperty({}, classes.datePickerToolbarButtonsDateTxtSelected, openView === 'hours'))
    }, format(date, 'HH'))), React.createElement(Typography, {
      variant: 'button',
      className: classes.datePickerToolbarButtonsDateTxt
    }, ":"), React.createElement(Button, {
      variant: 'text',
      onClick: function onClick() {
        return setOpenView('minutes');
      },
      className: classes.datePickerToolbarButtonsDateBtn
    }, React.createElement(Typography, {
      variant: 'button',
      className: classnames(classes.datePickerToolbarButtonsDateTxt, _defineProperty({}, classes.datePickerToolbarButtonsDateTxtSelected, openView === 'minutes'))
    }, format(date, 'mm', {
      locale: ruLocale
    }))))));
  };
};

function DateTimeComponent(props) {
  var _classnames7;

  var id = props.id,
      required = props.required,
      field = props.field,
      value = props.value,
      error = props.error,
      onFieldChange = props.onFieldChange,
      classes = props.classes,
      slim = props.slim,
      labelWidth = props.labelWidth,
      inputLabelRef = props.inputLabelRef,
      disabled = props.disabled;
  var formattedValue = formatValue(value);

  var _useState = useState(formattedValue),
      _useState2 = _slicedToArray(_useState, 2),
      componentValue = _useState2[0],
      setComponentValue = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      componentError = _useState4[0],
      setComponentError = _useState4[1];

  var ID = id || field.name;
  var min, max;

  if (field.params && field.params.date) {
    if (field.params.date.min) {
      min = field.params.date.min;
    }

    if (field.params.date.max) {
      max = field.params.date.max;
    }
  }

  useEffect(function () {
    setComponentValue(formatValue(value));
  }, [value]);
  /**
   * Изменение в поле ввода
   * @param date
   */

  var onChange = function onChange(date) {
    // Если дата валидная или строка ввода пустая, то показываем дефолтную ошибку
    if (isValid(date) || date === null) {
      setComponentError('');
    }

    setComponentValue(date);
  };
  /**
   * Потеря фокуса
   */


  var onBlur = function onBlur() {
    if (isValid(componentValue) && !componentError) {
      // Если дата валидная и нет ошибок, то сохраняем дату в текстовом формате
      onFieldChange(ID, format(componentValue, stringFormat));
    } else if (componentValue === null && formattedValue !== null) {
      // Если поле ввода пустое и есть дефолтная дата, то сохраняем пустую дату
      onFieldChange(ID, '');
    } else {
      // в остальных случаях возвращаем дефолтную дату и дефолтную ошибку
      setComponentValue(formattedValue);
      setComponentError('');
    }
  };
  /**
   * Клик по дате в календаре или очистка поля из календаря
   * @param date
   */


  var onAccept = function onAccept(date) {
    onFieldChange(ID, date === null ? '' : format(date, stringFormat));
  };
  /**
   * Очистка поля из календаря
   */


  var onClear = function onClear() {
    onFieldChange(ID, '');
  };
  /**
   * Устанавка сообщения об ошибке от компонента
   * @param errorMessage
   */


  var onError = function onError(errorMessage) {
    setComponentError(errorMessage);
  };

  return React.createElement(React.Fragment, null, React.createElement(MuiPickersUtilsProvider, {
    utils: DateFnsUtils,
    locale: ruLocale
  }, React.createElement(KeyboardDateTimePicker, {
    fullWidth: true,
    label: field.label,
    id: ID,
    name: field.name,
    variant: 'inline',
    onChange: onChange,
    onAccept: onAccept,
    onError: onError,
    value: componentValue,
    format: stringFormat,
    mask: value ? '__.__.____ __:__' : '',
    invalidDateMessage: "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u0442\u044B",
    minDateMessage: "\u0414\u0430\u0442\u0430 \u043D\u0435 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u043C\u0435\u043D\u044C\u0448\u0435 ".concat(min ? format(min, 'dd.MM.yyyy') : '01.01.1800'),
    maxDateMessage: "\u0414\u0430\u0442\u0430 \u043D\u0435 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 ".concat(max ? format(max, 'dd.MM.yyyy') : '01.01.2100'),
    minDate: min || minDate,
    maxDate: max || maxDate,
    error: !!componentError || !!error,
    helperText: componentError || error,
    required: !!required,
    inputVariant: 'outlined',
    ToolbarComponent: renderToolbarComponent({
      classes: classes
    }),
    disabled: disabled,
    InputProps: {
      labelWidth: labelWidth,
      onBlur: onBlur,
      classes: {
        disabled: classes.disabledInput,
        input: slim ? classes.slimOutlinedInput : classes.baseOutlinedInput,
        root: slim ? classes.slimOutlinedInputRoot : classes.baseOutlinedInputRoot,
        notchedOutline: classes.notchedOutline
      }
    },
    InputLabelProps: {
      ref: inputLabelRef,
      classes: {
        root: classnames(classes.label, labelWidth ? classnames(classes.clippedLabel, classes.clippedLabelWithAdornment) : '', slim ? classes.slimOutlinedLabel : classes.baseOutlinedLabel),
        shrink: classes.shrinkLabel
      }
    },
    ampm: false,
    autoOk: true,
    PopoverProps: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      }
    },
    KeyboardButtonProps: {
      size: slim ? 'small' : 'medium'
    },
    keyboardIcon: React.createElement(Event, {
      fontSize: slim ? 'small' : 'default'
    })
  })), componentValue && React.createElement(IconButton, {
    className: classnames(classes.clearButton, classes.dateClearButton, (_classnames7 = {}, _defineProperty(_classnames7, classes.clearButtonSlim, slim), _defineProperty(_classnames7, classes.dateClearButtonSlim, slim), _classnames7)),
    size: slim ? 'small' : 'medium',
    "aria-label": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u043B\u0435",
    onClick: onClear
  }, React.createElement(Clear, {
    fontSize: slim ? 'small' : 'default'
  })));
}

var DateTime = function DateTime(props) {
  var classes = props.classes,
      validation = props.validation,
      slim = props.slim;
  return React.createElement("div", {
    className: classes.fieldContainer
  }, React.createElement(DateTimeComponent, Object.assign({}, props)), validation && React.createElement("div", {
    className: classes.fieldLoaderContainer
  }, React.createElement(CircularProgress, {
    className: classnames(classes.fieldLoader, _defineProperty({}, classes.slimFieldLoader, !!slim)),
    size: slim ? 16 : 24,
    thickness: 4
  })));
};

export default DateTime;